function n(t) {
  return typeof t == "string" ? `s-${t}` : `n-${t}`;
}
export {
  n as createDataKey
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_utils/vue/create-data-key.js
// module id = 899
// module chunks = 41